import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { ValidationHelperService } from './validation-helper.service';

const helpersMap = new WeakMap();

@Directive({
    selector: '[libValidatorHelper],libValidatorHelper',
    standalone: false
})
export class ValidatorHelperDirective implements OnInit, OnChanges {
  @Input() label;
  @Input() who;
  @Input() model: UntypedFormGroup;
  @Input() control: AbstractControl;

  @Input() customIndex = null;

  private isRegistered = false;

  constructor(
    private elementRef: ElementRef,
    private validatorService: ValidationHelperService,
  ) {}

  ngOnInit() {
    this.tryRegisterElement();
  }

  ngOnChanges(changes: SimpleChanges) {
    // If label changes and we haven't registered yet, or if label was previously undefined/null
    if (changes['label'] && !this.isRegistered) {
      this.tryRegisterElement();
    }
  }

  private tryRegisterElement() {
    // Only register if we have a label (not undefined, null, or empty string)
    if (this.label && this.label !== null && this.label !== '') {
      this.validatorService.registerElement(
        this.model,
        this.customIndex ??
          this.elementRef.nativeElement.getAttribute('formControlName'),
        this.label,
        this.elementRef.nativeElement,
        this.control,
      );
      this.isRegistered = true;
    }
  }
}
